export { default as errorIcon } from "./error-icon.svg";
